import React from 'react';
import { TrackingInfoEvent } from '../../../../../../__generated__/loma';
import { useTheme } from '../../../../hooks/useTheme';
import styles from './ThemedHistory.module.css';

interface ThemedHistoryProps {
  event: TrackingInfoEvent;
}

const ThemedHistory = ({ event }: ThemedHistoryProps) => {
  const time = event.dateFormatted[1];
  let location = [event.city, event.state].filter(Boolean).join(', ');
  if (location !== '') {
    location = ` | ${location}`;
  }

  const { bodytextDefaultNone, smalltextDefaultNone } = useTheme();

  return (
    <li className={styles.listItem}>
      <span style={{ ...smalltextDefaultNone }}>
        <time>{time}</time>
        <span>{location}</span>
      </span>
      <p style={{ ...bodytextDefaultNone, margin: 0 }}>{event.description}</p>
    </li>
  );
};

export default ThemedHistory;
